export default __webpack_public_path__ + "static/media/jump_colour_green.50bf9f08.svg";